export enum ActionType {
  WEB_SEARCH = "web_search",
  DEEP_RESEARCH = "deep_research",
  WEB_RESEARCH = "web_research",
  READ_QR_CODE = "read_qr_code",
  READ_FILE = "read_file",
  WEB_FETCH = "web_fetch",
  URL_THUMBNAIL = "url_thumbnail",
  URL_THUMBNAILS = "url_thumbnails",
  DOCUMENT_SEARCH = "document_search",
  GET_DOCUMENT = "get_document",
  FORUM_SEARCH = "forum_search",
  FETCH_FORUM_POST = "fetch_forum_post",
  READ_CALENDAR = "read_calendar_events",
  BROWSER_USE = "browser_use",
  CREATE_LIST_DOCUMENT = "create_list_document",
  EDIT_LIST_DOCUMENT = "edit_list_document",
  UPSERT_STORAGE_DOCUMENT = "upsert_storage_document",
  CODE_EXECUTION = "code_execution",
  GENERATE_IMAGE = "generate_image",
  EDIT_IMAGE = "edit_image",
  GENERATE_DOCUMENT_IMAGE = "generate_document_image",
  DEFAULT = "default",
}

export const ACTION_DISPLAY_NAMES: Record<string, string> = {
  [ActionType.WEB_SEARCH]: "Searching the web",
  [ActionType.DEEP_RESEARCH]: "Running Deep Research",
  [ActionType.WEB_RESEARCH]: "Researching the internet",
  [ActionType.READ_QR_CODE]: "Scanning QR code",
  [ActionType.READ_FILE]: "Reading file",
  [ActionType.WEB_FETCH]: "Reading website",
  [ActionType.URL_THUMBNAIL]: "Reading website",
  [ActionType.URL_THUMBNAILS]: "Reading website",
  [ActionType.DOCUMENT_SEARCH]: "Searching documents",
  [ActionType.GET_DOCUMENT]: "Reading document",
  [ActionType.FORUM_SEARCH]: "Browsing Community",
  [ActionType.FETCH_FORUM_POST]: "Reading forum post",
  [ActionType.READ_CALENDAR]: "Reading calendar events",
  [ActionType.BROWSER_USE]: "Browsing the web",
  [ActionType.CREATE_LIST_DOCUMENT]: "Creating list document",
  [ActionType.EDIT_LIST_DOCUMENT]: "Updating list document",
  [ActionType.UPSERT_STORAGE_DOCUMENT]: "Updating document",
  [ActionType.CODE_EXECUTION]: "Creating file",
  [ActionType.GENERATE_IMAGE]: "Generating image",
  [ActionType.EDIT_IMAGE]: "Editing image",
  [ActionType.GENERATE_DOCUMENT_IMAGE]: "Generating image",
};

export function getActionType(name: string): ActionType {
  if (Object.values(ActionType).includes(name as ActionType)) {
    return name as ActionType;
  }
  return ActionType.DEFAULT;
}

export function getActionDisplayName(name: string): string | null {
  return ACTION_DISPLAY_NAMES[name] || null;
}
